import styles from "../../../styles/pages/Management.module.scss";
import { Input, Button, Dropdownlist } from "@qastanfit/qastan-ui"
import { useAppDispatch, useAppSelector } from "../../../hooks/redux";
import { RootState } from "../../../store";
import { useEffect, useState } from "react";
import { getAllUsers, handleCreateUser } from "../../../functions/fetch/user";
import { setNotification, setUsers } from "../../../redux/actions";

import * as crypto from 'crypto-js';

type Props = {
    onAdd: (value:Object) => void;
}

type NewUserState = Record<string, any> & {
    email: string;
    firstname: string;
    lastname: string;
    language: string;
    relnr: string;
    role: string;
}

const AddUser : React.FunctionComponent<Props> = ({onAdd}) => {
    const dispatch = useAppDispatch();
    //const roles = useAppSelector((state:RootState) => state.roles);
    const userdata:UserData = useAppSelector((state:RootState) => state.userdata);

    const [partnersList, setpartnersList] = useState<Array<string>>([]);
    const [rolesList, setrolesList] = useState<Array<string>>([]);
    const [selectedRole, setselectedRole] = useState("");
    const [selectedLanguage, setselectedLanguage] = useState("");
    const [selectedPartner, setselectedPartner] = useState("");

    const [newuserObject, setnewuserObject] = useState<NewUserState | null>();
    const [errorKeys, seterrorKeys] = useState<string[]>([]);

    const [loadingCreation, setloadingCreation] = useState<Boolean>(false);

    const [requiredFields, setrequiredFields] = useState(["email", "language", "role", "relnr"]);

    const changeValue = (key:keyof NewUserState, value:string) => {
        if(key){
            let tmp = [...errorKeys]
            const index = tmp.indexOf(key);
            if (index !== -1) {
                tmp.splice(index, 1);
            }
            seterrorKeys(tmp)
        }
        
        if (newuserObject) {
            setnewuserObject({ ...newuserObject, [key]: value });
        }
        else {
            setnewuserObject({ [key]: value } as NewUserState);
        }
    }

    const missingKeys = (newuserObject: NewUserState): string[] => {
        const objKeys = Object.keys(newuserObject);
        const expectedKeys = requiredFields;
        return expectedKeys.filter( key => !objKeys.includes(key))
    }

    const createUser = async () => {
        // if(newuserObject){
        //     if(missingKeys(newuserObject).length < 1){
        //         //Complete - create the account
        //         setloadingCreation(true);
        //         let tmp:createUserObject = {
        //             token: userdata.token,
        //             email: newuserObject.email,
        //             language: newuserObject.language,
        //             relnr: newuserObject.relnr,
        //             role: newuserObject.role,
        //             firstname: newuserObject.firstname,
        //             lastname: newuserObject.lastname
        //         }
        //         let createUser = await handleCreateUser(tmp);
        //         setloadingCreation(false);
        //         if(createUser.errorcode === 0){
        //             //Get new list of users
        //             let users = await getAllUsers(userdata);
        //             if(users.errorcode === 0){
        //                 //Save data in localStorage as cache
        //                 const stringified_users = JSON.stringify(users.object);
        //                 const encrypted_users = crypto.AES.encrypt(stringified_users, process.env.REACT_APP_SECRET || "");
        //                 localStorage.setItem("users", encrypted_users.toString());

        //                 //Save data in Redux state
        //                 dispatch(setUsers(users.object.users))
        //             }

        //             dispatch(setNotification({type:"success", title:"Succes", message:"Gebruiker aangemaakt"}))
        //             onAdd(true);
        //         }
        //         else {
        //             dispatch(setNotification({type:"error", title:"Mislukt", message:"Gebruiker aanmaken mislukt"}))
        //             console.error(createUser);
        //         }
        //     }
        //     else {
        //         //Missing keys - show errors
        //         seterrorKeys(missingKeys(newuserObject))
        //     }   
        // }
        // else {
        //     //Please fill in the form
        //     seterrorKeys(requiredFields)
        // }
    }

    return (
        <div className={styles.detail}>
            <div className={styles.header}>
                <h1 className={styles.title}>Gebruiker toevoegen</h1>
                <p className={styles.description}>Hier kan u een gebruiker toevoegen.</p>
            </div>

            <div className={styles.body}>
                <Input error={errorKeys.includes("email")} placeholder="E-mailadres" type="text" onChange={(e:HTMLInputElement)=>{changeValue("email", e.value)}}/>
                <Input error={errorKeys.includes("firstname")} placeholder="Voornaam" type="text" onChange={(e:HTMLInputElement)=>{changeValue("firstname", e.value)}}/>
                <Input error={errorKeys.includes("lastname")} placeholder="Familienaam" type="text" onChange={(e:HTMLInputElement)=>{changeValue("lastname", e.value)}}/>
                <Dropdownlist closeOnSelect error={errorKeys.includes("role")} onSelect={(v:any)=>{if(v.label.toLowerCase().includes("admin")){setselectedPartner(""); setrequiredFields(["email", "language", "role"])}else{setrequiredFields(["relnr", "email", "language", "role"])} changeValue("role", v.value); setselectedRole(`${v.value}_${v.label}`)}} options={rolesList} selected={selectedRole} placeholder="Rol" styling={{width:"100%", maxWidth:"unset"}} type="ID_LABEL"/>
                <Dropdownlist closeOnSelect error={errorKeys.includes("language")} onSelect={(v:any)=>{changeValue("language", v.value); setselectedLanguage(`${v.value}_${v.label}`)}} options={["N_Nederlands", "F_Frans", "E_Engels"]} selected={selectedLanguage} placeholder="Taal" styling={{width:"100%", maxWidth:"unset"}} type="ID_LABEL"/>
                {requiredFields.includes("relnr") && 
                <Dropdownlist closeOnSelect error={errorKeys.includes("relnr")} onSelect={(v:any)=>{changeValue("relnr", v.value); setselectedPartner(`${v.value}_${v.label}`)}} options={partnersList} selected={selectedPartner} placeholder={partnersList.length > 0 ? "Partner" : "Even geduld..."} type="ID_LABEL"/>
                }
                <div className={styles.actions}>
                    <Button disabled={loadingCreation} isLoading={loadingCreation} onClick={()=>{createUser()}}>Gebruiker aanmaken</Button>
                </div>
            </div>
        </div>
    )
}

export default AddUser;